(function ($) {
  var body = $('body');

  var wishListsArr = localStorage.getItem('wishListsArr')
    ? JSON.parse(localStorage.getItem('wishListsArr'))
    : [];
  localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));

  // ─── HELPERS ────────────────────────────────────────────────────────────────

  /** Refresh cart JSON view and update mini-cart in one call */
 function refreshCartView() {
  jQuery.getJSON('/cart.js', function(cart) {

    // cart count
    jQuery('#CartCount, #CartCountCavas').text(cart.item_count);

    // total
    jQuery('#cart_total').html(
      Shopify.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // reload mini cart
    if (typeof nuranium !== 'undefined') {
      nuranium.initMiniCart();
    }

  });
}

  /**
   * Find a variant that matches the given option values.
   * Pass `null` for options you don't care about.
   */
  function findVariant(variants, opt1, opt2, opt3, requireAvailable) {
    return variants.find(function (v) {
      return (opt1 === null || v.option1 === opt1)
          && (opt2 === null || v.option2 === opt2)
          && (opt3 === null || v.option3 === opt3)
          && (!requireAvailable || v.available);
    });
  }

  /**
   * Resolve which variant to select when a swatch radio changes.
   * Handles the opt-color position remapping logic.
   */
  function resolveSwatchVariant(variants, optPosition, optionIndex, variantValue, sel1, sel2, sel3) {
    var o1, o2, o3;

    function buildOpts(colorVal, otherVal, thirdVal) {
      // optPosition tells us which shopify option slot holds the color
      if (optPosition === 1)      { return [otherVal, colorVal, thirdVal]; }
      else if (optPosition === 2) { return [otherVal, thirdVal, colorVal]; }
      else                        { return [colorVal, otherVal, thirdVal]; }
    }

    var exact, fallback;

    switch (optionIndex) {
      case 0:
        var opts = buildOpts(variantValue, sel2, sel3);
        exact    = findVariant(variants, opts[0], opts[1], opts[2], false);
        fallback = exact || (function () {
          var fb = buildOpts(variantValue, null, null);
          return findVariant(variants, fb[0], fb[1], fb[2], false);
        }());
        return exact || fallback;

      case 1:
        var opts = buildOpts(sel1, variantValue, sel3);
        exact    = findVariant(variants, opts[0], opts[1], opts[2], false);
        fallback = exact || (function () {
          var fb = buildOpts(sel1, variantValue, null);
          return findVariant(variants, fb[0], fb[1], fb[2], false);
        }());
        return exact || fallback;

      case 2:
        var opts = buildOpts(sel1, sel2, variantValue);
        return findVariant(variants, opts[0], opts[1], opts[2], false);
    }
  }

  /**
   * Generic "add to cart" AJAX call.
   * — Only ONE request at a time (isCartAdding guard).
   * — Handles Shopify 429 rate-limit with automatic retry (up to 3 times).
   * @param {string} variantId
   * @param {jQuery} $btn       – button element (gets loading state)
   * @param {object} options    – { onSuccess, onError, onComplete }
   */
  var isCartAdding = false; // global guard — prevents duplicate simultaneous requests

  function ajaxAddToCart(variantId, $btn, options) {
    options = options || {};

    // Already processing — ignore extra clicks
    if (isCartAdding) return;
    if ($btn && $btn.hasClass('processing')) return;

    isCartAdding = true;
    if ($btn) $btn.addClass('processing').css('pointer-events', 'none').addClass('loading');

    function doRequest(retryCount) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variantId, quantity: 1 },
        dataType: 'json',
        success: function (cart) {
          // Single cart refresh — avoids double /cart.js call
          $.get('/cart?view=json', function (data) {
            $('#cart-info').html(data);
          }).always(function () {
            nuranium.updateMiniCart(); // updates count + total
          });

          if (theme.cart_status === 'show_popup') {
            nuranium.initAddToCart(cart.image, cart.title);
          }
          if (!$('.form-cart__extent').length) {
            nuranium.initCartExtend();
          }
          nuranium.PopupAddToCart();
          if (options.onSuccess) options.onSuccess(cart);
          if (theme.cart_status === 'show_minicart') {
            setTimeout(function () {
              $('#desktop_cart').addClass('active');
              $('.sidebar-overlay').addClass('act');
            }, 300);
          }
        },
        error: function (xhr, status) {
          // 429 = Too Many Requests — retry after delay (max 3 attempts)
          if (xhr.status === 429 && retryCount < 3) {
            var delay = 1000 * (retryCount + 1); // 1s, 2s, 3s
            console.warn('Cart add rate-limited (429). Retrying in ' + delay + 'ms… attempt ' + (retryCount + 1));
            setTimeout(function () { doRequest(retryCount + 1); }, delay);
            return; // don't fall through to complete cleanup yet
          }
          if (options.onError) options.onError(xhr, status);
          // Release guard on final error
          isCartAdding = false;
          if ($btn) $btn.css('pointer-events', 'auto').removeClass('loading processing');
          if (options.onComplete) options.onComplete();
        },
        complete: function (xhr) {
          // Only release on success or non-429 error (429 retries handle their own cleanup)
          if (xhr.status !== 429) {
            isCartAdding = false;
            if ($btn) $btn.css('pointer-events', 'auto').removeClass('loading processing');
            if (options.onComplete) options.onComplete();
          }
        }
      });
    }

    doRequest(0);
  }

  // ────────────────────────────────────────────────────────────────────────────

  $(document).ready(function () {
    $(document).ajaxStart(function () { nuranium.isAjaxLoading = true; });
    $(document).ajaxStop(function ()  { nuranium.isAjaxLoading = false; });
    nuranium.init();

    $('#popup-subscribe i.zmdi-close').on('click', function () {
      $(this).parents('#popup-subscribe').modal('hide');
    });

    nuranium.validLicense({
      shop: vinovathemes.main_info.shop,
      purchase_code: vinovathemes.main_info.lic,
      shopify_domain: vinovathemes.main_info.domain,
      status: vinovathemes.main_info.status
    });
  });

  // ============================================================
  var nuranium = {

    validLicense: function (t) {
      $.ajax({
        url: 'https://vinovathemes.com/license/check_license.php',
        type: 'post',
        data: t,
        success: function (t) {
          var a = JSON.parse(t);
          $('#Nov_purchasecode').on('contextmenu', function (t) { t.preventDefault(); });
          if (a.status === false) {
            $('#Nov_purchasecode').removeClass('hide hidden');
            $('#Nov_purchasecode-waring').html(a.msg);
            return;
          }
          $('#Nov_purchasecode-waring').html(a.msg).slideDown(250);
          setTimeout(function () { $('#Nov_purchasecode').remove(); }, 1000);
        }
      });
    },

    isAjaxLoading: false,

    init: function () {
      this.closeModal();
      this.novProductTabs();
      this.initNovWishListIcons();
      this.doAddOrRemoveWishlistProduct();
      this.doAddOrRemoveWishlist();

      if (body.hasClass('template-page') && $('.wishlist-page').length) {
        this.initNovWishListsPage();
      }

      this.ajaxProductAddToCart();
      this.ajaxAddToCartBtn();
      this.ajaxChangeFromCart();
      this.initMiniCart();
      this.ajaxRemoveFromCart();
      this.changeQuantityPageCart();
      this.initCollapseSidebarBlock();
      this.changeQuantityMiniCart();
      this.initproductItemColorSwatch();
      this.productItemSwatch();
      this.togglePopupAddToCart();

      if (body.hasClass('template-collection')) {
        this.initCollectionPageLoadmore();
      }
      if ($(window).width() > 767) {
        this.initQuickView();
      }
    },

    // ── Collection infinite scroll ──────────────────────────────────────────

    initCollectionPageLoadmore: function () {
      var scroll__infitiny    = $('.scroll__infitiny');
      var infiniteScrolling_url = '.scroll__infitiny a';

      if (!scroll__infitiny.length) return;

      body.off('click.initCollectionPageLoadmore', infiniteScrolling_url)
          .on('click.initCollectionPageLoadmore', infiniteScrolling_url, function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!$(this).hasClass('disabled')) {
              nuranium.ajaxCollectionPageLoadmoreGetContent($(this).data('href'));
            }
          });

      $(window).scroll(function () {
        if (nuranium.isAjaxLoading) return;
        var col    = $('.collection-filter__content');
        var posTop = col.offset().top + col.outerHeight() - $(window).height();
        if ($(this).scrollTop() > posTop && $(this).scrollTop() < posTop + 200) {
          var button = $(infiniteScrolling_url);
          if (button.length && !button.hasClass('disabled')) {
            nuranium.ajaxCollectionPageLoadmoreGetContent(button.data('href'));
          }
        }
      });
    },

    ajaxCollectionPageLoadmoreGetContent: function (url) {
      if (nuranium.isAjaxLoading) return;
      $.ajax({
        type: 'GET',
        url: url,
        beforeSend: function () { $('.scroll__infitiny').addClass('loading'); },
        success: function (data) {
          nuranium.ajaxCollectionPageLoadmoreMapData(data);
          if ($('.jdgm-widget').length) { jdgm.customizeBadges(); }
        },
        complete: function () { $('.scroll__infitiny').removeClass('loading'); }
      });
    },

    ajaxCollectionPageLoadmoreMapData: function (data) {
      var collectionTemplate       = $('.collection-template');
      var currentProductCollection = collectionTemplate.find('.product-collection');
      var currentProductCount      = collectionTemplate.find('.paging');
      var newCollectionTemplate    = $(data).find('.collection-template');
      var newProductCollection     = newCollectionTemplate.find('.product-collection');
      var newProductCount          = newCollectionTemplate.find('.paging');
      var newProductItem           = newProductCollection.children('.product--item');

      currentProductCount.replaceWith(newProductCount);
      if (newProductCollection.length) {
        currentProductCollection.append(newProductItem);
        var n = collectionTemplate.find('.product--item').length;
        var m = $('.pagination__bar').data('max');
        $('.pagination__count .count').text(n);
        $('.pagination__bar .progress').css('width', (n / m * 100) + '%');
      }
    },

    // ── Quick-add popup ─────────────────────────────────────────────────────

    togglePopupAddToCart: function () {
      $('.selector-wrapper-1').each(function () {
        if ($(this).hasClass('opt-color.hide')) {
          $(this).closest('.item-product__popup--variant').find('.btn-close-quick-add').hide();
        }
      });

      $(document).on('click', '.btn-quick-add', function () {
        $('.item-product__popup--variant').removeClass('act');
        $('.item-product .thumbnail-container').removeClass('popup-act');
        $(this).parent().find('.item-product__popup--variant').addClass('act');
        $(this).parents('.thumbnail-container').addClass('popup-act');
        if ($(this).parents('.nov-slick-carousel').data('nav')) {
          $(this).parents('.nov-slick-carousel').find('.slick-arrow').css('visibility', 'hidden');
        }
        if ($(this).parents('.collection-carousel').data('nav')) {
          $(this).parents('.collection-carousel').find('.slick-arrow').css('visibility', 'hidden');
        }
        $(this).parents('.item-product').find('.countdownfree').css('visibility', 'hidden');
      });

      $(document).on('click', '.btn-close-quick-add', function () {
        $(this).parent().removeClass('act');
        $(this).parents('.thumbnail-container').removeClass('popup-act');
        if ($(this).parents('.nov-slick-carousel').data('nav')) {
          $(this).parents('.nov-slick-carousel').find('.slick-arrow').css('visibility', 'visible');
        }
        if ($(this).parents('.collection-carousel').data('nav')) {
          $(this).parents('.collection-carousel').find('.slick-arrow').css('visibility', 'visible');
        }
        $(this).parents('.item-product').find('.countdownfree').css('visibility', 'visible');
      });
    },

    // ── Sidebar filter collapse ─────────────────────────────────────────────

    initCollapseSidebarBlock: function () {
      $(document).on('click', '.facets__label--title', function (e) {
        var a = $(e.currentTarget);
        var o = a.parents('.js-filter').find('.facets__content');
        if (a.parent().hasClass('act')) {
          a.parent().removeClass('act');
          a.parents('.js-filter').removeClass('act');
          o.slideUp();
        } else {
          a.parent().addClass('act');
          a.parents('.js-filter').addClass('act');
          o.slideDown();
        }
      });
    },

    closeModal: function () {
      $('.close-modal, .overlay').click(function () {
        $('.loading-modal').css({
          opacity: '0', visibility: 'hidden',
          transform: 'translateX(410px)', transition: 'all 0.3s'
        });
      });
    },

    // ── Product tabs ────────────────────────────────────────────────────────

    novProductTabs: function () {
      $('[data-product-tabs]').each(function () {
        var self        = $(this);
        var listTabs    = self.find('.list-product-tabs');
        var tabLink     = listTabs.find('[data-product-tabtop]');
        var tabContent  = self.find('[data-product-TabContent]');
        var linkActive  = self.find('.list-product-tabs .tab-links.active');
        var activeTab   = self.find('.product-tabs-content .tab-content.active');

        nuranium.doAjaxNovProductTabs(linkActive.data('href'), activeTab.find('.products-grid'), tabLink);

        tabLink.off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if ($(this).hasClass('active')) return;

          var curTab        = $(this);
          var curTabContent = $(curTab.data('target'));

          tabLink.removeClass('active');
          tabContent.removeClass('active');

          if (!curTabContent.find('.collection-carousel').hasClass('slick-initialized')) {
            nuranium.doAjaxNovProductTabs(curTab.data('href'), curTabContent.find('.products-grid'), tabLink);
          }

          curTab.addClass('active');
          curTabContent.addClass('active');

          if (curTabContent.find('.collection-carousel').hasClass('slick-initialized')) {
            var productGrid  = curTabContent.find('.collection-carousel');
            var num          = productGrid.find('.slick-slide').length;
            var num_act      = productGrid.find('.slick-active').length;
            var num_first    = productGrid.find('.slick-active:first').data('slick-index');
            var num_last     = productGrid.find('.slick-active:last').data('slick-index') + 1;
            var prev         = productGrid.parents('[data-product-tabs]').find('.nav-slider--prev');
            var next         = productGrid.parents('[data-product-tabs]').find('.nav-slider--next');
            var currentSlide = productGrid.find('.slick-current').data('slick-index');
            var page         = Math.ceil(((currentSlide || 0) + 1) / num_act);

            productGrid.parents('[data-product-tabs]').find('.total_nav').text(Math.ceil(num / num_act));
            productGrid.parents('[data-product-tabs]').find('.current_nav').text(
              Math.min(page, Math.ceil(num / num_act))
            );

            if (num === num_act) {
              prev.css('visibility', 'hidden');
              next.css('visibility', 'hidden');
            } else {
              prev.css('visibility', 'visible');
              next.css('visibility', 'visible');
            }
            num_first === 0 ? prev.addClass('disabled') : prev.removeClass('disabled');
            num - num_last > 0 ? next.removeClass('disabled') : next.addClass('disabled');
          }
        });
      });
    },

    doAjaxNovProductTabs: function (handle, curTabContent, tabLink) {
      $.ajax({
        type: 'GET',
        url: window.router + handle,
        beforeSend: function () {
          tabLink.css({ 'pointer-events': 'none', opacity: '0.6' });
        },
        success: function (data) {
          if (handle !== '/collections/?view=json' && handle !== '/collections/?view=new-json') {
            curTabContent.html($(data).find('.grid-item').html());
            curTabContent.find('.block:gt(' + (tabLink.data('limit') - 1) + ')').remove();
            if (curTabContent.hasClass('collection-carousel') && !curTabContent.hasClass('slick-initialized')) {
              nuranium.initNovProductTabsSlider(curTabContent.parent());
            }
            nuranium.initNovWishListIcons();
            setTimeout(function () {
              if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                window.SPR.registerCallbacks();
                window.SPR.initRatingHandler();
                window.SPR.initDomEls();
                window.SPR.loadProducts();
                window.SPR.loadBadges();
              }
            }, 500);
          }
        },
        complete: function () {
          tabLink.css({ 'pointer-events': 'auto', opacity: '1' });
        }
      });
    },

    initNovProductTabsSlider: function (tabslider) {
      tabslider.each(function () {
        var self        = $(this);
        var productGrid = self.find('.products-grid');
        var rtl         = $('html').hasClass('lang-rtl');

        if (productGrid.hasClass('slick-initialized')) return;

        productGrid.on('init reInit afterChange', function (event, slick, currentSlide) {
          var length   = productGrid.find('.slick-active').length;
          var page     = Math.ceil(((currentSlide || 0) + 1) / length);
          var numPages = Math.ceil(slick.slideCount / length);
          self.parents('[data-product-tabs]').find('.current_nav').text(page);
          self.parents('[data-product-tabs]').find('.total_nav').text(numPages);
          self.parents('[data-product-tabs]').find('.num_nav').css('opacity', '1');
        });

        productGrid.slick({
          nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
          prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
          rtl: rtl,
          slidesToShow:   productGrid.data('items_xxl'),
          slidesToScroll: productGrid.data('items_xxl'),
          rows:           productGrid.data('row'),
          row_mobile:     productGrid.data('row_mobile'),
          arrows:         productGrid.data('nav'),
          dots:           productGrid.data('dots'),
          infinite:       productGrid.data('loop'),
          adaptiveHeight: true,
          responsive: [
            { breakpoint: 1440, settings: { slidesToShow: productGrid.data('items'),    slidesToScroll: productGrid.data('items') } },
            { breakpoint: 1200, settings: { slidesToShow: productGrid.data('items_lg'), slidesToScroll: productGrid.data('items_lg'), arrows: false } },
            { breakpoint: 992,  settings: { slidesToShow: productGrid.data('items_md'), slidesToScroll: productGrid.data('items_md'), arrows: false } },
            { breakpoint: 768,  settings: { slidesToShow: productGrid.data('items_sm'), slidesToScroll: productGrid.data('items_sm'), arrows: false } },
            { breakpoint: 480,  settings: { slidesToShow: productGrid.data('items_xs'), slidesToScroll: productGrid.data('items_xs'), arrows: false, rows: productGrid.data('row_mobile') } }
          ]
        });

        function checkArrow(el, current) {
          var num     = $(el).find('.slick-slide').length;
          var num_act = $(el).find('.slick-active').length;
          var prev    = $(el).parents('[data-product-tabs]').find('.nav-slider--prev');
          var next    = $(el).parents('[data-product-tabs]').find('.nav-slider--next');
          if (num - num_act === 0) {
            prev.css('visibility', 'hidden');
            next.css('visibility', 'hidden');
          } else {
            prev.css('visibility', 'visible');
            next.css('visibility', 'visible');
          }
          current === 0 ? prev.addClass('disabled') : prev.removeClass('disabled');
          num - num_act <= current ? next.addClass('disabled') : next.removeClass('disabled');
        }

        checkArrow(this, productGrid.slick('slickCurrentSlide'));
        $(this).on('afterChange', function (event, slick, currentSlide) {
          checkArrow(this, currentSlide);
        });

        $('[data-product-tabs]').find('.nav-slider--prev').click(function () {
          $(this).parents('[data-product-tabs]').find('.tab-content.active').find(productGrid).slick('slickPrev');
        });
        $('[data-product-tabs]').find('.nav-slider--next').click(function () {
          $(this).parents('[data-product-tabs]').find('.tab-content.active').find(productGrid).slick('slickNext');
        });
      });
    },

    // ── Swatch (radio) ──────────────────────────────────────────────────────

    productItemSwatch: function () {
      $(document).on('change', '.selector-wrapper :radio', function () {
        var _self        = $(this);
        var product_item = _self.parents('.item-product');
        var item_swatch  = _self.parents('.product__popup-swatch');
        var product_info = product_item.data('json-product');
        var variants     = product_info.variants;
        var opt_position = product_item.find('.opt-color').data('opt-position');
        var option_index = _self.closest('[data-option-index]').data('option-index');
        var productInput = item_swatch.find('[name=id]');
        var variant_value = _self.val();

        var sel1 = item_swatch.find('.selector-wrapper-1').find('input:checked').val();
        var sel2 = item_swatch.find('.selector-wrapper-2').find('input:checked').val();
        var sel3 = item_swatch.find('.selector-wrapper-3').find('input:checked').val();

        item_swatch.find('.swatch-element').removeClass('soldout');
        item_swatch.find('.swatch-element :radio').prop('disabled', false);

        var selected_variant = resolveSwatchVariant(variants, opt_position, option_index, variant_value, sel1, sel2, sel3);
        if (!selected_variant) return;

        productInput.val(selected_variant.id);
        if (selected_variant.compare_at_price > selected_variant.price) {
          product_item.find('[data-compare-price-grid]').html(Shopify.formatMoney(selected_variant.compare_at_price, theme.moneyFormat));
        } else {
          product_item.find('[data-compare-price-grid]').html('');
        }
        product_item.find('[data-price-grid]').html(Shopify.formatMoney(selected_variant.price, theme.moneyFormat));
        _self.parents('.selector-wrapper').find('.form-label span').text(variant_value);

        nuranium.checkStatusSwatch(product_item, item_swatch);
        nuranium._updatePreorderText(item_swatch);
      });

      $(document).on('change', '.item-product__popup--variant select.single-option-selector', function () {
        var _self       = $(this);
        var product_item = _self.parents('.item-product');
        var item_swatch  = _self.parents('.product__popup-swatch');
        var variants     = product_item.data('json-product').variants;
        var option_index = _self.data('option');
        var pval         = _self.val();
        var productInput = item_swatch.find('[name=id]');
        var sel1 = item_swatch.find('[data-option="option1"]').val();
        var sel2 = item_swatch.find('[data-option="option2"]').val();
        var sel3 = item_swatch.find('[data-option="option3"]').val();

        var selected_variant;
        switch (option_index) {
          case 'option1':
            selected_variant = findVariant(variants, pval, sel2, null, true)
                            || findVariant(variants, pval, null, null, true);
            break;
          case 'option2':
            selected_variant = findVariant(variants, sel1, pval, null, true);
            break;
          case 'option3':
            selected_variant = findVariant(variants, sel1, sel2, pval, true);
            break;
        }

        if (selected_variant) productInput.val(selected_variant.id);
        _self.parents('.selector-wrapper').find('.form-label span').text(pval);
        nuranium.checkStatusSwatch(product_item, item_swatch);
        nuranium._updatePreorderText(item_swatch);
      });

      $(document).on('click', '.selector-wrapper .unavailable :radio', function () {
        $(this).parents('.item-product').find('[data-btn-addtocart]').attr('disabled', 'disabled');
      });
    },

    /** Shared helper: update add-to-cart button text based on inventory policy */
    _updatePreorderText: function (item_swatch) {
      var current_variant_id  = item_swatch.find('.current_variant_id').attr('value');
      var inventory_policy    = item_swatch.find('.product-form__variants [value="' + current_variant_id + '"]').data('inventory_policy');
      var text = (inventory_policy === 'continue')
        ? window.inventory_text.preorder
        : window.inventory_text.add_to_cart;
      item_swatch.find('[data-btn-addtocart] .add-to-cart-text').text(text);
    },

    // ── Color swatch (thumbnail) ────────────────────────────────────────────

    initproductItemColorSwatch: function () {
      body.off('click.toggleClass').on('click.toggleClass', '.item-swatch li label', function () {
        var self         = $(this);
        var title        = self.attr('data-title').replace(/^\s+|\s+$/g, '');
        var product_item = self.closest('.item');

        self.parents('.item-swatch').find('li label').removeClass('active');
        self.addClass('active');
        product_item.find('.product__label-color').find('[data-change-title]').text(title);

        if (self.data('with-one-option') !== undefined) {
          var quantity         = self.data('quantity');
          var inventory_policy = self.data('inventory_policy');
          product_item.find('[name="id"]').val(self.data('with-one-option'));

          if (quantity > 0) {
            product_item.find('[data-btn-addtocart]').removeClass('disabled').removeAttr('disabled');
            product_item.find('[data-btn-addtocart] .add-to-cart-text').text(
              inventory_policy === 'continue' ? window.inventory_text.preorder : window.inventory_text.add_to_cart
            );
          } else {
            product_item.find('[data-btn-addtocart]').addClass('disabled').attr('disabled', 'disabled');
            product_item.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.sold_out);
          }

          var price        = self.data('price');
          var comparePrice = self.data('compare_at_price');
          if (comparePrice > price) {
            product_item.find('[data-compare-price-grid]').html(Shopify.formatMoney(comparePrice, theme.moneyFormat));
          } else {
            product_item.find('[data-compare-price-grid]').html('');
          }
          product_item.find('[data-price-grid]').html(Shopify.formatMoney(price, theme.moneyFormat));
        } else {
          var product_info = $(this).parents('.item-product').data('json-product');
          if (product_info) nuranium.checkStatusSwatch(self.parents('.item-product'));

          if ($('.template-collection').length) {
            if (self.parents('.product-collection').hasClass('products-list')) {
              product_item.find('.product-details').find('[data-value="' + title + '"]').find('label').trigger('click');
            } else {
              product_item.find('.product__popup-swatch:eq(0)').find('[data-value="' + title + '"]').find('label').trigger('click');
            }
          } else {
            product_item.find('[data-value="' + title + '"]').find('label').trigger('click');
          }
        }

        var new_image = self.data('img');
        if (new_image) {
          product_item.find('.thumbnail-container .product__thumbnail, .thumbnail-container .product__thumbnail-second').attr({
            'data-srcset': new_image, 'data-src': new_image, src: new_image, srcset: new_image
          });
          return false;
        }
      });

      body.off('click.showmore').on('click.showmore', '.item-swatch-more .show_more', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parents('.item-swatch').toggleClass('show--more');
        $(this).children().text($(this).parents('.item-swatch').hasClass('show--more') ? '-' : '+');
      });
    },

    /**
     * Update swatch availability states.
     * Shared helper used by both radio-swatch and select-swatch paths.
     */
    checkStatusSwatch: function (product_item, item_swatch) {
      var product_info = product_item.data('json-product');
      var variants     = product_info.variants;

      if (item_swatch === undefined) item_swatch = product_item;

      if (window.use_color_swatch) {
        var opt_position = product_item.find('.opt-color').data('opt-position');
        var sel1 = item_swatch.find('[data-option-index="0"]').find('input:checked').val();
        var sel2 = item_swatch.find('[data-option-index="1"]').find('input:checked').val();
        var sel3 = item_swatch.find('[data-option-index="2"]').find('input:checked').val();

        /** Build option array respecting opt_position colour remapping */
        function buildOpts(colorVal, o2, o3) {
          if (opt_position === 1)      return [o2, colorVal, o3];
          else if (opt_position === 2) return [o2, o3, colorVal];
          else                         return [colorVal, o2, o3];
        }

        product_item.find('[data-option-index]').each(function () {
          var option_index = $(this).data('option-index');
          $(this).find('.swatch-element').each(function () {
            var swatch_val = $(this).data('value');
            var opts_avail, opts_any;

            switch (option_index) {
              case 0:
                opts_avail = buildOpts(swatch_val, null, null);
                opts_any   = opts_avail;
                break;
              case 1:
                opts_avail = buildOpts(sel1, swatch_val, null);
                opts_any   = opts_avail;
                break;
              case 2:
                opts_avail = buildOpts(sel1, sel2, swatch_val);
                opts_any   = opts_avail;
                break;
            }

            var available  = findVariant(variants, opts_avail[0], opts_avail[1], opts_avail[2], true);
            var anyVariant = findVariant(variants, opts_any[0],   opts_any[1],   opts_any[2],   false);

            if (available) {
              $(this).removeClass('soldout unavailable').addClass('available');
              $(this).find(':radio').prop('disabled', false);
              $(this).removeAttr('data-toggle').removeAttr('data-target');
            } else if (anyVariant) {
              $(this).addClass('soldout').removeClass('unavailable available');
              $(this).find(':radio').prop('disabled', false);
              $(this).attr({ 'data-toggle': 'modal', 'data-target': '#Form_newletter' });
            } else {
              $(this).addClass('unavailable').removeClass('soldout available');
              $(this).find(':radio').prop('checked', false);
              $(this).attr({ 'data-toggle': 'modal', 'data-target': '#Form_newletter' });
            }
          });
        });

        if (item_swatch.find('.swatch-element.soldout').find('input:checked').length) {
          item_swatch.find('[data-btn-addtocart]').attr('disabled', true);
        } else {
          item_swatch.find('[data-btn-addtocart]').removeAttr('disabled');
        }

        item_swatch.find('.selector-wrapper:not(.opt-color)').each(function () {
          if ($(this).find('.swatch-element').find('input:checked').length < 1) {
            var $first = $(this).find('.swatch-element.available').eq(0);
            if (!$first.length) $first = $(this).find('.swatch-element.soldout').eq(0);
            $first.find('label').trigger('click');
          }
        });

      } else {
        // Select-based swatches
        var sel1 = item_swatch.find('.item-product__popup--variant [data-option="option1"]').val();
        var sel2 = item_swatch.find('.item-product__popup--variant [data-option="option2"]').val();
        var sel3 = item_swatch.find('.item-product__popup--variant [data-option="option3"]').val();

        item_swatch.find('.item-product__popup--variant [data-option]').each(function () {
          var option_index = $(this).data('option-index');
          $(this).find('option').each(function () {
            var swatch_val = $(this).val();
            var available, anyVariant;

            switch (option_index) {
              case 0:
                available  = findVariant(variants, swatch_val, null, null, true);
                anyVariant = findVariant(variants, swatch_val, null, null, false);
                break;
              case 1:
                available  = findVariant(variants, sel1, swatch_val, null, true);
                anyVariant = findVariant(variants, sel1, swatch_val, null, false);
                break;
              case 2:
                available  = findVariant(variants, sel1, sel2, swatch_val, true);
                anyVariant = findVariant(variants, sel1, sel2, swatch_val, false);
                break;
            }

            if (available) {
              $(this).removeAttr('disabled').removeClass('soldOut unavailable');
            } else if (anyVariant) {
              $(this).addClass('soldOut').removeClass('unavailable').removeAttr('disabled');
            } else {
              $(this).addClass('unavailable').removeClass('soldOut').attr('disabled', 'disabled');
            }
          });
        });

        if (item_swatch.find('.item-product__popup--variant .single-option-selector').find('option.soldOut:selected').length) {
          item_swatch.find('[data-btn-addtocart]').addClass('disabled').attr('disabled', true);
        } else {
          item_swatch.find('[data-btn-addtocart]').removeClass('disabled').removeAttr('disabled');
        }
      }
    },

    // ── Wishlist ─────────────────────────────────────────────────────────────

    initNovWishListsPage: function () {
      if (typeof Storage === 'undefined') { alert('Storage no support!'); return; }
      if (!wishListsArr.length) return;
      wishListsArr.forEach(function (item) { nuranium.createNovWishListTplItem(item); });
    },

    initNovWishListIcons: function () {
      if (!wishListsArr.length) return;

      wishListsArr.forEach(function (handle) {
        var icon = $('[data-product-handle="' + handle + '"]');
        icon.addClass('whislist-added');
        icon.find('.wishlist-text').text(theme.strings.remove_wishlist);
      });

      if (typeof Storage === 'undefined') { alert('Storage no support!'); return; }

      setTimeout(function () {
        wishListsArr.forEach(function (item) { nuranium.setNovAddedForWishlistIcon(item); });
      }, 1000);
    },

    setNovAddedForWishlistIcon: function (ProductHandle) {
      var wishlistElm = $('[data-product-handle="' + ProductHandle + '"]');
      var inList      = wishListsArr.indexOf(ProductHandle) >= 0;
      $('.WishlistCount').text(wishListsArr.length);
      wishlistElm
        .toggleClass('whislist-added', inList)
        .find('.wishlist-text').text(inList ? theme.strings.remove_wishlist : theme.strings.addto_wishlist);
      wishlistElm.attr('title', inList ? theme.strings.remove_wishlist : theme.strings.addto_wishlist);
    },

    /** Shared wishlist toggle logic */
    _toggleWishlist: function (self, productId, ProductHandle, title, image) {
      var idxArr = wishListsArr.indexOf(ProductHandle);

      if (!self.hasClass('whislist-added')) {
        self.addClass('whislist-added').find('.wishlist-text').text(theme.strings.remove_wishlist);
        self.attr({ title: theme.strings.remove_wishlist, 'data-original-title': theme.strings.remove_wishlist });
        $('.tooltip-inner').text(theme.strings.remove_wishlist);

        if (title) {
          $('.loading-modal').find('.product-title').html(title);
          if (image) $('.loading-modal').find('.product-image').attr('srcset', image).attr('src', image);
          $('.loading-modal').find('.btn-wishlist').show();
          $('.loading-modal').css({ opacity: '1', visibility: 'initial', transform: 'translateX(0)', transition: 'all 0.3s' }).addClass('novload');
          setTimeout(function () {
            $('.loading-modal').css({ opacity: '0', visibility: 'hidden', transform: 'translateX(410px)', transition: 'all 0.3s' }).removeClass('novload');
          }, 5000);
        }

        if ($('[data-wishlist-container]').length) nuranium.createNovWishListTplItem(ProductHandle);
        wishListsArr.push(ProductHandle);
      } else {
        self.removeClass('whislist-added').find('.wishlist-text').text(theme.strings.addto_wishlist);
        self.attr({ title: theme.strings.addto_wishlist, 'data-original-title': theme.strings.addto_wishlist });
        $('.tooltip-inner').text(theme.strings.addto_wishlist);
        $('[data-wishlist-added="wishlist-' + productId + '"]').remove();
        wishListsArr.splice(idxArr, 1);
      }

      localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
      nuranium.setNovAddedForWishlistIcon(ProductHandle);
    },

    doAddOrRemoveWishlist: function () {
      $(document).off('click.addOrRemoveWishlist', '.item-product [data-icon-wishlist]')
                 .on('click.addOrRemoveWishlist',  '.item-product [data-icon-wishlist]', function (e) {
        e.preventDefault();
        var self    = $(this);
        var title   = self.parents('.item-product').find('.product__title').html();
        var image   = self.parents('.item-product').find('.product__thumbnail').attr('srcset')
                   || self.parents('.item-product').find('.product__thumbnail').attr('src');
        nuranium._toggleWishlist(self, self.data('id'), self.data('product-handle'), title, image);
      });
    },

    doAddOrRemoveWishlistProduct: function () {
      $(document).off('click.addOrRemoveWishlist', '.product-single a[data-icon-wishlist]')
                 .on('click.addOrRemoveWishlist',  '.product-single a[data-icon-wishlist]', function (e) {
        e.preventDefault();
        var self  = $(this);
        var title = self.parents('.product-single').find('.product-single__title').html();
        var image = self.parents('.product-single').find('.product-single__photos .thumblist .thumbItem img').attr('src');
        nuranium._toggleWishlist(self, self.data('id'), self.data('product-handle'), title, image);
      });
    },

    createNovWishListTplItem: function (ProductHandle) {
      var wishListCotainer = $('[data-wishlist-container]');
      jQuery.getJSON(window.router + '/products/' + ProductHandle + '.js', function (product) {
        var price_min            = Shopify.formatMoney(product.price_min, theme.moneyFormat);
        var compare_at_price_min = Shopify.formatMoney(product.compare_at_price_min, theme.moneyFormat);
        var hasSecondImage       = typeof product.images[1] !== 'undefined';

        var html = '<div class="item col-lg-3 col-md-4 col-6" data-wishlist-added="wishlist-' + product.id + '">'
          + '<div class="item-product" data-product-id="product-' + product.handle + '">'
          + '<div class="inner-top">'
          + '<div class="product-top thumbnail-container' + (hasSecondImage ? ' has-multiimage' : '') + '">'
          + '<a href="' + product.url + '">'
          + '<img class="product__thumbnail" src="' + product.featured_image + '" alt="' + (product.featured_image.alt || '') + '">'
          + (hasSecondImage ? '<img class="product__thumbnail-second" src="' + product.images[1] + '" alt="' + (product.images[1].alt || '') + '">' : '')
          + '</a>'
          + '<div class="button--top">'
          + '<div class="productWishList">'
          + '<a class="btnProductWishlist item-product__wishlist whislist-added" data-icon-wishlist href="#" data-product-handle="' + product.handle + '" data-id="' + product.id + '">'
          + '<i class="zmdi zmdi-favorite"></i></a></div>'
          + '<div class="productQuickView d-none d-md-block">'
          + '<a class="btnProductQuickview" href="#" data-url="/products/' + product.handle + '?view=quick_view" data-product-url="/products/' + product.handle + '" data-handle="' + product.handle + '" data-pid="' + product.id + '">'
          + '<i class="zmdi zmdi-collection-image-o"></i></a></div>'
          + '</div></div>'
          + '<div class="product__info">'
          + '<div class="product__title"><a href="' + product.url + '" title="' + product.title + '">' + product.title + '</a></div>'
          + (compare_at_price_min > price_min
              ? '<div class="price-sale"><span class="special-price" data-price-grid>' + price_min + '</span><span class="old-price" data-compare-price-grid>' + compare_at_price_min + '</span></div>'
              : '<div class="price-regular"><span data-price-grid>' + price_min + '</span></div>')
          + '</div></div></div>';

        wishListCotainer.append(html);
      });
    },

    // ── Cart: add-to-cart buttons ────────────────────────────────────────────

    /** Handles .btnAddToCart buttons (collection / quick-add popups) */
    ajaxAddToCartBtn: function () {
      $(document).off('click', 'button.btnAddToCart').on('click', 'button.btnAddToCart', function (e) {
        e.preventDefault();
        var $this = $(this);
        var variantId = $this.closest('form').find('[name="id"]').val();
        console.log('id=' + variantId + '&quantity=1');
        ajaxAddToCart(variantId, $this, {
          onSuccess: function () {
            $this.parents('form').find('.product-form__item-error').addClass('hidden');
            $(document).find('.quickviewClose').trigger('click');
          },
          onError: function () {
            $this.parents('form').find('.product-form__item-error').removeClass('hidden');
          }
        });
      });
    },

    /** Handles .product-form__cart-submit (product page) */
    ajaxProductAddToCart: function () {
      $(document).on('click', '.product-form__cart-submit', function (e) {
        e.preventDefault();
        var $this = $(this);
        var variantId = $this.closest('form').find('[name="id"]').val();
        $('.lookbook-modal').modal('hide');
        ajaxAddToCart(variantId, $this, {
          onSuccess: function () {
            $('.cart_extend').removeClass('act');
            $('.cart_extend--label').removeClass('act');
          },
          onComplete: function () {
            $('body').removeClass('cart_popup_opened loading');
            $('.nov-close, .cart_popup_opened .nov-ready').on('click', function () {
              if ($('body').hasClass('template-cart')) window.location.reload();
            });
            $(document).find('.zmdi-close').trigger('click');
          },
          onError: function () {
            $this.find('.add-to-cart-text').text(window.inventory_text.sold_out);
          }
        });
      });
    },

    initAddToCart: function (image, title) {
      $.ajax({
        url: '/cart/?view=upsell',
        dataType: 'html',
        type: 'GET',
        beforeSend: function () { $('body').addClass('cart_popup_opened'); },
        success: function (data) {
          $.magnificPopup.open({
            items: {
              src: '<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">' + data + '</div></div>',
              type: 'inline'
            },
            removalDelay: 500,
            closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
            callbacks: {
              beforeOpen: function () { this.st.mainClass = 'nov-move-horizontal'; },
              open: function () { nuranium.PopupAddToCart(); },
              close: function () {
                if ($('body').hasClass('template-cart')) {
                  window.location.reload();
                } else {
                  $('body').removeClass('cart_popup_opened open_quick_variants loading');
                  $('#content_cart__popup_nt').empty();
                }
              }
            }
          });
        },
        complete: function () {
          nuranium.PopupAddToCart();
          $('.loader').remove();
          if (title) {
            var cartMessage = '<div class="cart-message d-flex align-items-center mb-20">'
              + '<i class="zmdi zmdi-notifications-active"></i><strong>' + title + '</strong> - '
              + theme.strings.cart_message_html + '</div>';
            $('.cart-popup__content').prepend(cartMessage);
          }
        },
        error: function () { $('.loader').remove(); }
      });
    },

    updateMiniCart: function () {
      Shopify.getCart(function (cart) { nuranium.doUpdateMiniCart(cart); });
    },

    doUpdateMiniCart: function (cart) {
      $('#CartCount, #CartCountCavas').text(cart.item_count);
      $('#cart_total').html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
      $('.cart-popup-heading span').html('There are ' + cart.item_count + ' item(s) in your cart');
    },

    ajaxChangeFromCart: function () {
      $(document).on('change', '.cart__popup-qty--input, .cart__mini-qty--input', function (e) {
        e.preventDefault();
      });
    },

    // ── Popup cart qty / remove ──────────────────────────────────────────────

    PopupAddToCart: function () {
      function PopupUpdateCart(_id, new_qty) {
        $('.cart__popup').addClass('loading');
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + new_qty + '&id=' + _id,
          dataType: 'json',
          success: function () {
            $.get('/cart?view=up_ajax', function (data) {
              data = $(data);
              var t_html      = $(data.get(0)).html();
              var t_threshold = $(data.get(2)).html();
              var t_total     = $('.cart__popup #' + _id).find('.cart__popup-total .amount');
              $('.cart__popup #' + _id).find('.cart__popup-qty--input').val(new_qty);
              t_total.html(Shopify.formatMoney(parseFloat(t_total.data('price')) * new_qty, theme.moneyFormat));
              $('#cart__popup_total').html(t_html);
              $('#threshold_bar_popup').html(t_threshold);
            }).always(function () {
              $('.cart__popup').removeClass('loading');
            });
            refreshCartView();
          },
          error: function () { $('.cart__popup').removeClass('loading'); }
        });
      }

      $(document).on('click', '.cart__popup-qty', function (e) {
        e.preventDefault();
        var $this    = $(this);
        var $qty     = $this.siblings('.cart__popup-qty--input');
        var $id      = $qty.attr('data-id');
        var $qtyinput = parseFloat($qty.val());
        var $step    = parseFloat($qty.attr('step'));
        var $min     = parseFloat($qty.attr('min'));
        var $max     = parseFloat($qty.attr('max'));
        var $newqty;

        if ($this.hasClass('cart__popup-qty--plus')) {
          $newqty = $qtyinput + $step;
          if ($newqty > $max && $max > 0) { $qty.val($max); return; }
        } else if ($this.hasClass('cart__popup-qty--minus')) {
          $newqty = $qtyinput - $step;
          if ($newqty === 0) {
            $qty.val(parseInt($qty.attr('value')));
            $this.parents('.cart__popup-item').find('.cart__popup-remove').trigger('click');
            return;
          }
          if ($newqty < $min || $qtyinput < 0) { if ($qtyinput < 0) alert('Invalid'); return; }
        }

        PopupUpdateCart($id, $newqty);
      });

      $(document).on('click', '.cart__popup-remove', function (e) {
        e.preventDefault();
        var $this   = $(this);
        var $qty    = $this.siblings('.cart__popup-quantity').find('.cart__popup-qty--input');
        var $id     = $this.find('a').attr('data-product-id');
        var $ptitle = $this.parent('.cart__popup-item').find('.cart__popup-title a').text();

        $('.cart__popup').addClass('loading');

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=0&id=' + $id,
          dataType: 'json',
          success: function () {
            $.get('/cart?view=up_ajax').always(function (data) {
              data = $(data);
              $('#cart__popup_total').html($(data.get(0)).html());
              $('#threshold_bar_popup').html($(data.get(2)).html());
              $('.cart__popup #' + $id).addClass('hide');
              $('.cart__popup .cart-message').html(
                '<i class="rbb-icon-delete-outline-2"></i> <strong>' + $ptitle + '</strong> - has been removed into your shopping cart.'
              ).addClass('removed');
              $('.cart__popup').removeClass('loading');
              $this.parents('.cart__popup-item').remove();
            });
            refreshCartView();
          }
        });
      });
    },

    // ── Mini cart ────────────────────────────────────────────────────────────

    initMiniCart: function () {
      jQuery.getJSON('/cart.js', function (cart) {
        $('#CartCount, #CartCountCavas').text(cart.item_count);
        $('#cart-info').html('');
        $('#desktop_cart').addClass('item_count');
        var html = '';

        if (cart.item_count > 0) {
          html += '<form action="/cart" method="post" class="cart ajaxcart">'
            + '<input class="js-form-discount" type="hidden" name="discount" value="">'
            + '<div class="ajaxcart__inner"><div class="ajaxcart__inner--content">';

          cart.items.forEach(function (item, i) {
            var image = Shopify.resizeImage(item.image, '220x');
            var price = Shopify.formatMoney(item.price, theme.moneyFormat);
            html += '<div class="ajaxcart__product" data-line="' + i + '">'
              + '<div class="media">'
              + '<a href="' + item.url + '" class="position-relative">'
              + '<img class="d-flex product-image" src="' + image + '" alt="' + item.title + '" title="' + item.title + '"></a>'
              + '<div class="media-body">'
              + '<a class="product-name" href="' + item.url + '"><span class="title">' + item.product_title + '</span>'
              + (item.variant_title ? '<span class="bt_s">' + item.variant_title + '</span>' : '')
              + '</a>'
              + '<div class="mb-5"></div>'
              + '<span class="product-price"><span class="money">' + price + '</span></span>'
              + '<div class="cart__item-bottom d-flex align-items-center mt-10">'
              + '<div class="cart__mini--qty d-flex align-items-center">'
              + '<a class="cart__mini-qty cart__mini-qty--minus" href="#">-</a>'
              + '<input class="cart__mini-qty--input" type="number" name="updates[]" id="updates_' + item.key + '" data-price="' + item.price + '" data-id="' + item.id + '" data-line="' + i + '" step="1" value="' + item.quantity + '" min="1" max="" pattern="[0-9]*" />'
              + '<a class="cart__mini-qty cart__mini-qty--plus" href="#">+</a>'
              + '</div>'
              + '<span class="remove-from-cart" rel="nofollow" href="#" title="remove from cart" data-line="' + i + '" data-product-id="' + item.id + '"><i class="rbb-icon-delete-outline-2"></i></span>'
              + '</div></div></div></div>';
          });

          html += '</div></div><div class="ajaxcart__footer">'
            + '<div class="subtotal d-flex align-items-center justify-content-between">'
            + '<label>' + theme.strings.total + '</label>'
            + '<span>' + Shopify.formatMoney(cart.total_price, theme.moneyFormat) + '</span>'
            + '</div>'
            + '<div class="cart_extend--label row spacing-0 d-md-none mb-15">';

          if (theme.cart_note)              html += nuranium._minicartExtendBtn('note',              '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.90371 16.5062V14.553L15.8459 8.61073L17.7992 10.564L11.8569 16.5062H9.90371ZM0 10.729V9.0784H8.2531V10.729H0ZM18.9821 9.38102L17.0289 7.42779L17.8267 6.62999C17.9734 6.48326 18.166 6.4099 18.4044 6.4099C18.6428 6.4099 18.8354 6.48326 18.9821 6.62999L19.7799 7.42779C19.9266 7.57451 20 7.76708 20 8.0055C20 8.24392 19.9266 8.4365 19.7799 8.58322L18.9821 9.38102ZM0 6.18982V4.5392H12.9298V6.18982H0ZM0 1.65062V0H12.9298V1.65062H0Z" fill="black"/></svg>');
          if (theme.cart_shipping_calculator) html += nuranium._minicartExtendBtn('estimate-shipping', '<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.18182 14.5227C3.43939 14.5227 2.80682 14.2614 2.28409 13.7386C1.76136 13.2159 1.5 12.5833 1.5 11.8409H0V1.36364C0 1 0.136364 0.681818 0.409091 0.409091C0.681818 0.136363 1 0 1.36364 0H14.5227V3.79545H16.9091L20 7.90909V11.8409H18.3864C18.3864 12.5833 18.125 13.2159 17.6023 13.7386C17.0795 14.2614 16.447 14.5227 15.7045 14.5227C14.9621 14.5227 14.3295 14.2614 13.8068 13.7386C13.2841 13.2159 13.0227 12.5833 13.0227 11.8409H6.86364C6.86364 12.5833 6.60227 13.2159 6.07955 13.7386C5.55682 14.2614 4.92424 14.5227 4.18182 14.5227ZM4.18182 13.1591C4.54545 13.1591 4.85606 13.0303 5.11364 12.7727C5.37121 12.5152 5.5 12.2045 5.5 11.8409C5.5 11.4773 5.37121 11.1667 5.11364 10.9091C4.85606 10.6515 4.54545 10.5227 4.18182 10.5227C3.81818 10.5227 3.50758 10.6515 3.25 10.9091C2.99242 11.1667 2.86364 11.4773 2.86364 11.8409C2.86364 12.2045 2.99242 12.5152 3.25 12.7727C3.50758 13.0303 3.81818 13.1591 4.18182 13.1591ZM1.36364 10.4773H1.86364C2.12121 10.0682 2.44697 9.74242 2.84091 9.5C3.23485 9.25758 3.67424 9.13636 4.15909 9.13636C4.64394 9.13636 5.08712 9.26136 5.48864 9.51136C5.89015 9.76136 6.2197 10.0833 6.47727 10.4773H13.1591V1.36364H1.36364V10.4773ZM15.7045 13.1591C16.0682 13.1591 16.3788 13.0303 16.6364 12.7727C16.8939 12.5152 17.0227 12.2045 17.0227 11.8409C17.0227 11.4773 16.8939 11.1667 16.6364 10.9091C16.3788 10.6515 16.0682 10.5227 15.7045 10.5227C15.3409 10.5227 15.0303 10.6515 14.7727 10.9091C14.5152 11.1667 14.3864 11.4773 14.3864 11.8409C14.3864 12.2045 14.5152 12.5152 14.7727 12.7727C15.0303 13.0303 15.3409 13.1591 15.7045 13.1591ZM14.5227 8.52273H18.75L16.2273 5.15909H14.5227V8.52273Z" fill="black"/></svg>');
          if (theme.cart_discount_code)    html += nuranium._minicartExtendBtn('discount',           '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.95268 13.905L13.0909 10.755C13.2553 10.59 13.3748 10.4062 13.4496 10.2037C13.5243 10.0012 13.5616 9.7875 13.5616 9.5625C13.5616 9.0825 13.3935 8.67375 13.0573 8.33625C12.721 7.99875 12.3138 7.83 11.8356 7.83C11.5367 7.83 11.2379 7.9275 10.939 8.1225C10.6401 8.3175 10.3113 8.6325 9.95268 9.0675C9.59402 8.6325 9.26525 8.3175 8.96638 8.1225C8.6675 7.9275 8.36862 7.83 8.06974 7.83C7.59153 7.83 7.18431 7.99875 6.84807 8.33625C6.51183 8.67375 6.34371 9.0825 6.34371 9.5625C6.34371 9.7875 6.38107 10.0012 6.45579 10.2037C6.53051 10.4062 6.65006 10.59 6.81445 10.755L9.95268 13.905ZM9.77335 18C9.59402 18 9.42217 17.97 9.25778 17.91C9.0934 17.85 8.93649 17.7525 8.78705 17.6175L0.381071 9.18C0.246575 9.03 0.14944 8.8725 0.0896637 8.7075C0.0298878 8.5425 0 8.37 0 8.19V1.35C0 0.96 0.127024 0.6375 0.381071 0.3825C0.635118 0.1275 0.956413 0 1.34496 0H8.1594C8.33873 0 8.51806 0.0262501 8.69738 0.0787501C8.87671 0.13125 9.0411 0.2325 9.19053 0.3825L17.5517 8.775C17.8506 9.075 18 9.40875 18 9.77625C18 10.1437 17.8506 10.4775 17.5517 10.7775L10.7372 17.6175C10.6177 17.7375 10.472 17.8313 10.3001 17.8988C10.1283 17.9663 9.95268 18 9.77335 18ZM9.77335 16.65L16.5878 9.81L8.1594 1.35H1.34496V8.19L9.77335 16.65ZM3.69863 4.86C4.01245 4.86 4.28518 4.74375 4.51681 4.51125C4.74844 4.27875 4.86426 4.005 4.86426 3.69C4.86426 3.375 4.74844 3.10125 4.51681 2.86875C4.28518 2.63625 4.01245 2.52 3.69863 2.52C3.38481 2.52 3.11208 2.63625 2.88045 2.86875C2.64882 3.10125 2.533 3.375 2.533 3.69C2.533 4.005 2.64882 4.27875 2.88045 4.51125C3.11208 4.74375 3.38481 4.86 3.69863 4.86V4.86Z" fill=""/></svg>');

          html += '</div>';

          // Free shipping threshold bar
          if (theme.show_free_shipping) {
            var price          = cart.total_price;
            var freeVal        = theme.freeshipping_value;
            html += '<div id="threshold_bar_popup_minicart">';
            if (parseFloat(price / 100) < parseFloat(freeVal)) {
              var remain = (parseFloat(freeVal) - parseFloat(price / 100)).toFixed(0);
              html += '<div class="cart_threshold">'
                + '<div class="threshold_spend">' + theme.strings.spend + ' ' + Shopify.formatMoney(remain * 100, theme.moneyFormat) + ' ' + theme.strings.spend__html + '</div>'
                + '<div class="threshold_bar"><span class="animate" style="width:' + (price / freeVal).toFixed(0) + '%!important"><span>' + (price / freeVal).toFixed(0) + '%</span></span></div>'
                + '</div>';
            } else {
              html += '<div class="threshold_spend spend_congrats"><span>' + theme.strings.content_threshold + '<i class="rbb-icon-delivery-11"></i></span></div>'
                + '<div class="threshold_bar threshold_congrats"><span class="animate" style="width:100%!important"><span>100%</span></div>';
            }
            html += '</div>';
          }

          html += '<div class="btn_submit">';
          if (theme.terms_conditions_enable) {
            html += '<input type="checkbox" name="checkout__input" value="1" id="checkout__canvas" class="hide">';
          }
          html += '<a href="/cart" class="btn btn-success"><span>' + theme.strings.view_cart + '</span></a>'
            + '<button type="submit" class="btn cart__checkout" name="checkout"><span>' + theme.strings.check_out + '</span></button>';
          if (theme.terms_conditions_enable) {
            html += '<label for="checkout__canvas" class="d-flex align-items-center mt-20">'
              + '<span class="custom-checkbox pointer d-inline-flex align-items-center justify-content-center"><i class="zmdi zmdi-check"></i></span>'
              + '<span class="label__text">' + theme.proceed_to_checkout + '</span></label>';
          }
          html += '</div></div></form>';

          $('#cart-info').append(html);
          $('#cart_total').html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));

          var i = $('.ajaxcart__inner').outerHeight();
          var f = $('.ajaxcart__footer').outerHeight();
          var c = $('.ajaxcart').height() - 30;
          if (i + f >= c) { $('.ajaxcart__footer').addClass('h_scroll'); }
          if (!$('.form-cart__extent').length) { nuranium.initCartExtend(); }

        } else {
          html = '<div class="cart cart_empty">'
            + '<div class="empty_title text-center">' + theme.strings.cart_empty + '</div>'
            + '<div class="text-center mt-40 block_link_cart">' + $('.link_to_collection_cart_empty').html() + '</div>'
            + '</div>';
          $('#cart-info').append(html);
          $('#cart_total').html('$0');
          $('#desktop_cart').removeClass('item_count');
          $('.form-cart__extent').remove();
        }
      });
    },

    /** Small helper to build extend-label buttons */
    _minicartExtendBtn: function (label, svgHtml) {
      return '<div class="extend--label__item col" data-label="' + label + '">' + svgHtml + '<i class="zmdi zmdi-close"></i></div>';
    },

    // ── Quick view ────────────────────────────────────────────────────────────

    initQuickView: function () {
      $(document).on('click', '.btnProductQuickview', function (e) {
        e.preventDefault();
        $('.lookbook-modal').modal('hide');
        var $this = $(this);

        $.ajax({
          beforeSend: function () { $('body').addClass('open_gl_quick_view'); },
          url: $this.attr('data-url'),
          success: function (data) {
            $.magnificPopup.open({
              items: {
                src: '<div class="nov-with-anim popup-quick-view" id="content_quickview">' + data + '</div>',
                type: 'inline'
              },
              removalDelay: 500,
              closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
              callbacks: {
                beforeOpen: function () { this.st.mainClass = 'nov-move-horizontal'; },
                open: function () {
                  var rtl = $('html').hasClass('lang-rtl');
                  $('.quickview_slick').slick({
                    nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
                    prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
                    rtl: rtl, slidesToShow: 1, slidesToScroll: 1, arrows: true, dots: false, infinite: true, adaptiveHeight: true
                  });
                  $('variant-radios label').click(function () {
                    setTimeout(function () {
                      var dindex = $('.quickview_slick').find('.item.act').attr('data-slick-index');
                      $('.quickview_slick').slick('slickGoTo', dindex);
                    }, 300);
                  });
                  Shopify.PaymentButton.init();
                  setTimeout(function () {
                    if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                      window.SPR.registerCallbacks(); window.SPR.initRatingHandler();
                      window.SPR.initDomEls(); window.SPR.loadProducts(); window.SPR.loadBadges();
                    }
                  }, 1000);
                  nuranium.initNovWishListIcons();
                  if ($('.jdgm-widget').length) { jdgm.customizeBadges(); }
                  jQuery('variant-radios :radio').change(function () {
                    jQuery(this).parents('fieldset').find('.variant_current').text(jQuery(this).val());
                  });
                  $(document).on('click', '#content_quickview .soldout', function () {
                    $('#content_quickview .zmdi-close').trigger('click');
                  });
                },
                close: function () {
                  $('#content_quickview').empty();
                  $('body').removeClass('open_gl_quick_view cart_popup_opened open_quick_variants');
                  $('body').find('.tooltip').remove();
                }
              }
            });
          },
          complete: function () { Shopify.PaymentButton.init(); }
        }).done(function () {
          $this.removeClass('btn-loading');
          $('body').removeClass('loading');
          $('body').find('.tooltip').remove();
        });

        fetch($this.attr('data-product-url'))
          .then(function (r) { return r.text(); })
          .then(function (responseText) {
            var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            var sectionId    = responseHTML.querySelector('.product-template__container').getAttribute('data-section-id');
            var qv           = document.getElementById('content_quickview');
            if (!qv) return;

            qv.querySelector('variant-radios').setAttribute('data-section', sectionId);
            qv.querySelector('.product-template__container').setAttribute('data-section-id', sectionId);
            qv.querySelector('.product-template__container').id = 'ProductSection-' + sectionId;
            qv.querySelector('#ProductPrice-templateQV').id     = 'ProductPrice-' + sectionId;
            if (qv.querySelector('#ComparePrice-templateQV')) {
              qv.querySelector('#ComparePrice-templateQV').id   = 'ComparePrice-' + sectionId;
            }
            qv.querySelector('form').id = 'product-form-' + sectionId;
            qv.querySelector('form').setAttribute('data-section', sectionId);

            qv.querySelectorAll('.item_img').forEach(function (el) {
              el.setAttribute('data-media-id', sectionId + el.getAttribute('data-media-id'));
            });
            qv.querySelectorAll('input[type=radio]').forEach(function (el) {
              el.setAttribute('form', sectionId);
            });
          });
      });
    },

    // ── Cart: remove ─────────────────────────────────────────────────────────

    ajaxRemoveFromCart: function () {
      $('#cart-info').on('click', '.remove-from-cart', function (e) {
        e.preventDefault();
        var $id = $(this).attr('data-product-id');
        $.ajax({
          type: 'POST', url: '/cart/change.js',
          data: 'quantity=0&id=' + $id, dataType: 'json',
          success: function () {
            if ($('body').hasClass('template-cart')) { window.location.reload(); }
            else { nuranium.initMiniCart(); }
          }
        });
      });
    },

    // ── Mini-cart qty ────────────────────────────────────────────────────────

    changeQuantityMiniCart: function () {
      function MiniCartUpdate(_id, new_qty) {
        $.ajax({
          type: 'POST', url: '/cart/change.js',
          data: 'quantity=' + new_qty + '&id=' + _id, dataType: 'json',
          success: function () {
            $.get('/cart?view=up_ajax', function (data) {
              data = $(data);
              $('#cart-info').find('.subtotal span').html($(data.get(0)).html());
              $('#threshold_bar_popup_minicart .cart_threshold').html($(data.get(2)).html());
            });
            refreshCartView();
          }
        });
      }

      $(document).on('click', '.cart__mini-qty', function (e) {
        e.preventDefault();
        var $this    = $(this);
        var $qty     = $this.siblings('.cart__mini-qty--input');
        var $id      = $qty.attr('data-id');
        var $qtyinput = parseFloat($qty.val());
        var $step    = parseFloat($qty.attr('step'));
        var $min     = parseFloat($qty.attr('min'));
        var $max     = parseFloat($qty.attr('max'));
        var $newqty;

        if ($this.hasClass('cart__mini-qty--plus')) {
          $newqty = $qtyinput + $step;
          if ($newqty > $max && $max > 0) { $qty.val($max); return; }
          $qty.val($newqty);
        } else if ($this.hasClass('cart__mini-qty--minus')) {
          $newqty = $qtyinput - $step;
          if ($newqty === 0) {
            $qty.val(parseInt($qty.attr('value')));
            $this.parents('.ajaxcart__product').find('.remove-from-cart').trigger('click');
            return;
          }
          if ($newqty < $min) return;
          if ($qtyinput < 0) { alert('Invalid'); return; }
          $qty.val($newqty);
        }

        MiniCartUpdate($id, $newqty);
      });

      $(document).on('change', '.cart__mini-qty--input', function () {
        var $this  = $(this);
        var $newqty = parseFloat($this.val());
        var $id    = $this.attr('data-id');
        var $max   = parseFloat($this.attr('max'));
        if ($newqty > $max && $max > 0) { $this.val($max); return; }
        if ($newqty === 0) { $this.parents('.ajaxcart__product').find('.remove-from-cart').trigger('click'); return; }
        MiniCartUpdate($id, $newqty);
      });
    },

    // ── Page cart qty ────────────────────────────────────────────────────────

    changeQuantityPageCart: function () {
      function ShopifyCartChange(line, quantity, callback) {
        $.ajax({
          type: 'POST', url: '/cart/change.js',
          data: 'quantity=' + quantity + '&line=' + line,
          dataType: 'json',
          success: function (cart) { if (typeof callback === 'function') callback(cart); }
        });
      }

      $(document).on('change keyup', '.cart__qty-input, .cart__popup-qty--input', function () {
        var $this = $(this);
        var line  = $this.data('line');
        var val   = parseInt($this.val());
        var price = $this.data('price');
        var max   = $this.attr('max');
        if (isNaN(val)) return;

        max = isNaN(parseInt(max)) ? 9999 : parseInt(max);
        if (val > max) { $this.attr('value', max).val(max); val = max; }
        if (val <= 0) { $this.closest('tr').remove(); }

        ShopifyCartChange(line, val, function (res) {
          $('.cart__subtotal').html(Shopify.formatMoney(res.total_price, theme.moneyFormat));
          $this.parents('.cart_item').find('.product-subtotal').html(Shopify.formatMoney(price * val, theme.moneyFormat));
          $('#CartCount, #CartCountCavas').html(res.item_count);
          $('.cart__heading span').html('There are ' + res.item_count + ' items in your cart');
          jQuery.get('/cart?view=ship', function (data) { $('#threshold_bar_popup').html(data); });
          refreshCartView();
        });
      });

      $(document).on('click', '.plus, .minus', function () {
        var $qty       = $(this).closest('.cart__qty').find('.cart__qty-input');
        var currentVal = parseFloat($qty.val()) || 0;
        var max        = parseFloat($qty.attr('max'))  || '';
        var min        = parseFloat($qty.attr('min'))  || 0;
        var step       = parseFloat($qty.attr('step')) || 1;

        if ($(this).is('.plus')) {
          $qty.val(max && currentVal >= max ? max : currentVal + step);
        } else {
          if (min && currentVal <= min) { $qty.val(min); }
          else if (currentVal > 0) { $qty.val(currentVal - step); }
        }
        $qty.trigger('change');
      });

      $(document).on('click', '.quick_view-qty-plus, .quick_view-qty-minus', function () {
        var $qty       = $(this).closest('.quick_view_qty').find('input[name="quantity"]');
        var currentVal = parseFloat($qty.val()) || 0;
        var max        = parseFloat($qty.attr('max'))  || '';
        var min        = parseFloat($qty.attr('min'))  || 0;
        var step       = parseFloat($qty.attr('step')) || 1;

        if ($(this).is('.quick_view-qty-plus')) {
          $qty.val(max && currentVal >= max ? max : currentVal + step);
        } else {
          if (min && currentVal <= min) { $qty.val(min); }
          else if (currentVal > 0) { $qty.val(currentVal - step); }
        }
      });
    },

    // ── Cart extend panel ────────────────────────────────────────────────────

    initCartExtend: function () {
      jQuery.get('/cart?view=extend', function (data) {
        $('.block_cart_top').before(data);
        var placement = $('html').hasClass('lang-rtl') ? 'right' : 'left';
        $('.extend--label__item').attr('data-placement', placement);
      });

      setTimeout(function () {
        if ($('#shipping-calculator').length > 0) {
          // Countries helper
          if (typeof Countries !== 'undefined') {
            Countries.updateProvinceLabel = function (e, t) {
              if (typeof e !== 'string' || !Countries[e] || !Countries[e].provinces) return;
              if (typeof t !== 'object') { t = document.getElementById('address_province_label'); if (!t) return; }
              t.innerHTML = Countries[e].label;
              var r = jQuery(t).parent();
              r.find('.custom-style-select-box-inner').html(Countries[e].provinces[0]);
            };
          }

          if (typeof Shopify.Cart === 'undefined') Shopify.Cart = {};

          Shopify.Cart.ShippingCalculator = (function () {
            var _config = {
              submitButton: 'Calculate shipping',
              submitButtonDisabled: 'Calculating...',
              templateId: 'shipping-calculator-response-template',
              wrapperId: 'wrapper-response',
              customerIsLoggedIn: false,
              moneyFormat: '${{amount}}'
            };

            function _formatRate(e) {
              if (typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(e, _config.moneyFormat);
              if (typeof e === 'string') e = e.replace('.', '');
              var a = /\{\{\s*(\w+)\s*\}\}/;
              var i = _config.moneyFormat;
              function r(e, decimals, thousands, decimal) {
                decimals = decimals === undefined ? 2 : decimals;
                thousands = thousands === undefined ? ',' : thousands;
                decimal   = decimal   === undefined ? '.' : decimal;
                if (isNaN(e) || e == null) return 0;
                e = (e / 100).toFixed(decimals);
                var parts = e.split('.');
                return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
              }
              switch (i.match(a)[1]) {
                case 'amount':                          return i.replace(a, r(e, 2));
                case 'amount_no_decimals':              return i.replace(a, r(e, 0));
                case 'amount_with_comma_separator':     return i.replace(a, r(e, 2, '.', ','));
                case 'amount_no_decimals_with_comma_separator': return i.replace(a, r(e, 0, '.', ','));
              }
            }

            function _render(e) {
              var t = jQuery('#' + _config.templateId);
              var r = jQuery('#' + _config.wrapperId);
              if (!t.length || !r.length) return;
              var n   = Handlebars.compile(jQuery.trim(t.text()));
              jQuery(n(e)).appendTo(r);
              if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
                var i = jQuery('[name=currencies]').length ? jQuery('[name=currencies]').val()
                      : (jQuery('#currencies span.selected').length ? jQuery('#currencies span.selected').attr('data-currency') : '');
                if (i) Currency.convertAll(shopCurrency, i, '#wrapper-response span.money, #estimated-shipping span.money');
              }
            }

            function _enableButtons()  { jQuery('.get-rates').removeAttr('disabled').removeClass('disabled').val(_config.submitButton); }
            function _disableButtons() { jQuery('.get-rates').val(_config.submitButtonDisabled).attr('disabled', 'disabled').addClass('disabled'); }

            function _fullMessagesFromErrors(e) {
              var t = [];
              jQuery.each(e, function (k, v) { jQuery.each(v, function (i, m) { t.push(k + ' ' + m); }); });
              return t;
            }

            function _onError(xhr) {
              jQuery('#estimated-shipping').hide().find('em').empty();
              _enableButtons();
              var data = eval('(' + xhr.responseText + ')');
              var feedback = data.message
                ? data.message + '(' + data.status + '): ' + data.description
                : 'Error : ' + _fullMessagesFromErrors(data).join('; ') + '.';
              if (feedback === 'Error : country is not supported.') feedback = 'We do not ship to this destination.';
              _render({ rates: [], errorFeedback: feedback, success: false });
              jQuery('#' + _config.wrapperId).show();
            }

            function _onCartShippingRatesUpdate(rates, address) {
              _enableButtons();
              var label = (address.zip ? address.zip + ', ' : '') + (address.province ? address.province + ', ' : '') + address.country;
              if (rates.length) {
                jQuery('#estimated-shipping em').html(rates[0].price === '0.00' ? 'FREE' : _formatRate(rates[0].price));
                rates.forEach(function (r) { r.price = _formatRate(r.price); });
              }
              _render({ rates: rates, address: label, success: true });
              jQuery('#' + _config.wrapperId + ', #estimated-shipping').fadeIn();
            }

            function _pollForCartShippingRatesForDestination(address) {
              return function poll() {
                jQuery.ajax('/cart/async_shipping_rates', {
                  dataType: 'json',
                  success: function (r, n, a) {
                    if (a.status === 200) { _onCartShippingRatesUpdate(r.shipping_rates, address); }
                    else { setTimeout(poll, 500); }
                  },
                  error: _onError
                });
              };
            }

            function _getCartShippingRatesForDestination(address) {
              jQuery.ajax({
                type: 'POST', url: '/cart/prepare_shipping_rates',
                data: jQuery.param({ shipping_address: address }),
                success: _pollForCartShippingRatesForDestination(address),
                error: _onError
              });
            }

            function _init() {
              new Shopify.CountryProvinceSelector('address_country', 'address_province', { hideElement: 'address_province_container' });
              var $country = jQuery('#address_country');
              var $label   = jQuery('#address_province_label').get(0);
              if (typeof Countries !== 'undefined') {
                Countries.updateProvinceLabel($country.val(), $label);
                $country.change(function () { Countries.updateProvinceLabel($country.val(), $label); });
              }
              jQuery('.get-rates').click(function () {
                _disableButtons();
                jQuery('#' + _config.wrapperId).empty().hide();
                _getCartShippingRatesForDestination({
                  zip:      jQuery('#address_zip').val()      || '',
                  country:  jQuery('#address_country').val()  || '',
                  province: jQuery('#address_province').val() || ''
                });
              });
              if (_config.customerIsLoggedIn) jQuery('.get-rates:eq(0)').trigger('click');
            }

            return {
              show: function (e) { jQuery.extend(_config, e || {}); jQuery(function () { _init(); }); },
              getConfig: function () { return _config; },
              formatRate: function (e) { return _formatRate(e); }
            };
          }());

          Shopify.Cart.ShippingCalculator.show({
            submitButton:          theme.strings.shippingCalcSubmitButton,
            submitButtonDisabled:  theme.strings.shippingCalcSubmitButtonDisabled,
            customerIsLoggedIn:    theme.strings.shippingCalcCustomerIsLoggedIn,
            moneyFormat:           theme.strings.shippingCalcMoneyFormat
          });
        }
      }, 1000);
    }
  };

})(jQuery);